import React from "react";
import { DistanceUnitsDropdown } from "./DistanceUnitsDropdown";
import { MeasureDropdown } from "./Dropdown";

interface AreaProps {
  distance: number;
  selectedDistanceUnits: string;
  setSelectedDistanceUnits: (units: string) => void;
  area: number;
  selectedAreaUnits: string;
  setSelectedAreaUnits: (units: string) => void;
}
export const Area = (props: AreaProps) => {
  const [areaUnitOptions] = React.useState([
    { value: "acres", label: "Acres" },
    { value: "square-meters", label: "Sq Meters" },
    { value: "square-kilometers", label: "Sq Kilometers" },
    { value: "square-feet", label: "Sq Feet" },
    { value: "square-yards", label: "Sq Yards" },
    { value: "square-miles", label: "Sq Miles" },
  ]);
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <div className="flex-1">
          <span>Distance: </span>
          <span>
            {props.distance &&
              parseFloat(props.distance.toFixed(2)).toLocaleString()}
          </span>
        </div>
        <DistanceUnitsDropdown
          selectedDistanceUnits={props.selectedDistanceUnits}
          setSelectedDistanceUnits={props.setSelectedDistanceUnits}
        />
      </div>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <span>Area: </span>
          <span>
            {props.area && parseFloat(props.area.toFixed(2)).toLocaleString()}
          </span>
        </div>
        <MeasureDropdown
          selection={props.selectedAreaUnits}
          setSelection={props.setSelectedAreaUnits}
          options={areaUnitOptions}
        />
      </div>
    </div>
  );
};
